import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { FunctionalTeam } from '@/features/team/team.def.ts'

export type ChecklistItemActionLog = {
  username: string
  action: string
  timestamp: string
}

export type ChecklistItem = {
  title: string
  complete: boolean
  isPendingAction: boolean // to the viewer
  canRead: boolean // to the viewer
  canWrite: boolean // to the viewer
  order: number
  actionLogs: ChecklistItemActionLog[]
  deadlineDueDaysAfterJoin: number
  deadline: string
  refDateType?: string
  assignee: string
  disabled: boolean
}

export type ChecklistGroupItem = {
  groupName: string
  items: ChecklistItem[]
}

export type ChecklistExtraDetails = {
  fieldName: string
  value: string
}

export type Checklist = {
  id: number
  employeeId: string
  employeeName: string
  checklistGroupItems: ChecklistGroupItem[]
  isComplete: boolean
  isPendingAction: boolean // to the viewer
  configName?: string // for HC only
  category: string
  target: string
  country: string
  employmentEntity: string
  joinDate?: string
  createdAt: string
  position?: string
  lineManagerEmployeeId?: string
  updatedAt: string
  extraDetails: ChecklistExtraDetails[]
}

export type ChecklistSelectOption = Omit<Checklist, 'checklistGroupItems'>

export const ChecklistCategory = {
  PreOnboarding: 'Pre-onboarding',
  Onboarding: 'Onboarding',
  Offboarding: 'Offboarding',
}
export const ChecklistCategoryOptions = stringArrayToSelectOptions(Object.values(ChecklistCategory))

export const ChecklistTarget = {
  Investment: 'Investment',
  NonInvestment: 'Non-Investment',
}
export const ChecklistTargetOptions = stringArrayToSelectOptions(Object.values(ChecklistTarget))

export const ChecklistType = {
  PreOnboardingNonInvestment: 'Pre-onboarding - Non-Investment',
  PreOnboardingInvestment: 'Pre-onboarding - Investment',
  OnboardingNonInvestment: 'Onboarding - Non-Investment',
  OnboardingInvestment: 'Onboarding - Investment',
  OffboardingNonInvestment: 'Offboarding - Non-Investment',
  OffboardingInvestment: 'Offboarding - Investment',
}
export const ChecklistTypeOptions = stringArrayToSelectOptions(Object.values(ChecklistType))

export const ChecklistItemAssignee = {
  HumanCapital: FunctionalTeam.HumanCapital,
  Administration: FunctionalTeam.Administration,
  Finance: FunctionalTeam.Finance,
  Compliance: FunctionalTeam.Compliance,
  IT: FunctionalTeam.IT,
  ExecutiveAdmin: FunctionalTeam.ExecutiveAdmin,
  DataManagementTeam: FunctionalTeam.DataManagementTeam,
  LineManager: 'Line Manager',
}

export const ChecklistItemAssigneeOptions = stringArrayToSelectOptions(Object.values(ChecklistItemAssignee))

export type ChecklistConfigItem = {
  description: string
  assignee: string
  dayOffset: number
  refDateType: string
}

export type ChecklistConfigSection = {
  sectionName: string
  items: ChecklistConfigItem[]
}

export type ChecklistConfig = {
  id: number
  name: string
  category: string
  target: string
  customFieldNames: string[]
  sections: ChecklistConfigSection[]
}